export default "__VITE_ASSET__xhTJH$_c__"